module.exports = __webpack_public_path__ + "static/media/ASRVoicemail.c1d2416e.png";